/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-danger */
import { memo } from 'react';

import currencyFormatter from 'currency-formatter';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';

import { alignerFavouritesClicked } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { countryMap } from '../../language.config';
import { productLinks, analyticProductData, pageCodeMap } from '../../links.config';
import { products } from '../../recoil/atoms/products';
import { cartPrice } from '../../recoil/selectors/cart';
import { gumletAWSClean } from '../../utils/utils';

import '../../styles/slider.scss';

function SliderItem4(props) {
  const { data } = props;
  const cartPriceDetails = useRecoilValue(cartPrice);
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const productData = i18n.t('product_data');
  const productsData = useRecoilValue(products);
  const key = data.productKey;
  const itemData = Object.keys(productsData[key].colorValues).includes('BLACK')
    ? productsData[key].colorValues.BLACK : Object.values(productsData[key].colorValues)[0];

  return (
    <>
      <div className="slider-item-wrapper-4">
        <div className="slider-box">
          <div className="slider-box__image">
            <div className="slider-box__tags">
              {itemData.configuration.discountLabel && (<span>{itemData.configuration.discountLabel}</span>)}
            </div>
            <img
              data-src={gumletAWSClean(itemData.configuration?.productImage.imageUrl)}
              data-gumlet="true"
              alt={productData[key]?.name}
            />
          </div>
          <div className="slider-box__content">
            <span className="tag-item">{productData[key]?.tag && (productData[key]?.tag)}</span>
            <h4>{productData[key]?.name}</h4>
            <p>
              {itemData.configuration.strikeoutPrice !== 0 && (
              <s>
                {currencyFormatter.format(itemData.configuration.strikeoutPrice,
                  { code: cartPriceDetails.currency_code,
                    ...(cartPriceDetails.currency_code === 'SGD' && { symbol: 'S$' }) })}

              </s>
              )}
              <b>
                {currencyFormatter.format(itemData.price, { code: cartPriceDetails.currency_code,
                  ...(cartPriceDetails.currency_code === 'SGD' && { symbol: 'S$' }) })}

              </b>
            </p>
          </div>
        </div>
        <Link
          href={`/[lng]/${data.catalogue.page ? pageCodeMap[data.catalogue?.page?.code]
            : productLinks[data.productKey]}`}
          as={`/${i18n.activeLocale}/${data.catalogue.page ? pageCodeMap[data.catalogue?.page?.code]
            : productLinks[data.productKey]}`}
        >
          <a
            className="linker"
            role="presentation"
            onClick={() => {
              alignerFavouritesClicked(countryMap[country],
                analyticProductData[itemData.productKey].category,
                analyticProductData[itemData.productKey].product);
            }}
          >
            &nbsp;
          </a>
        </Link>
      </div>
    </>
  );
}
export default memo(SliderItem4);

SliderItem4.propTypes = {
  data: PropTypes.shape()
};

SliderItem4.defaultProps = {
  data: PropTypes.shape()
};
